import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { X, History, User, Clock, ArrowRight } from 'lucide-react';

const AuditHistoryModal = ({ isOpen, onClose, tableName, recordId }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && tableName && recordId) {
      setLoading(true);
      console.log(`🔍 Fetching Audit for: ${tableName} / ${recordId}`); // ديباج عشان نشوف الطلب رايح لمين
      
      const token = localStorage.getItem('token'); // نضمن إن التوكن موجود
      
      axios.get(`/api/audit/history/${tableName}/${recordId}`, {
          headers: { 'Authorization': `Bearer ${token}` }
      })
      .then(res => {
        console.log("✅ Audit Data Received:", res.data);
        setLogs(res.data);
      })
      .catch(err => {
        console.error("❌ Audit Fetch Failed:", err);
        setLogs([]);
      })
      .finally(() => setLoading(false));
    }
  }, [isOpen, tableName, recordId]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white w-full max-w-4xl rounded-xl shadow-2xl overflow-hidden flex flex-col max-h-[80vh]">
        {/* Header */}
        <div className="bg-[#1a3353] text-white p-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <History size={20} className="text-orange-400" />
            <div>
              <h3 className="font-black text-sm uppercase tracking-widest">Audit Trail Explorer</h3>
              <p className="text-[10px] opacity-60">History for {tableName}: {recordId}</p>
            </div>
          </div>
          <button onClick={onClose} className="hover:bg-white/10 p-1 rounded-full"><X size={20}/></button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-4 bg-slate-50 custom-scrollbar">
          {loading ? (
            <div className="flex justify-center py-20 animate-pulse font-black text-slate-400 uppercase text-[10px]">Retrieving Audit Records...</div>
          ) : logs.length === 0 ? (
            <div className="text-center py-20 text-slate-300 italic uppercase text-[10px]">No audit trails found for this record</div>
          ) : (
            <div className="space-y-4">
              {logs.map((log, idx) => (
                <div key={idx} className="bg-white border rounded-lg shadow-sm overflow-hidden border-l-4 border-l-blue-600">
                  <div className="bg-slate-50 px-4 py-2 flex justify-between items-center border-b">
                    <div className="flex items-center gap-4 text-[10px] font-black text-slate-600 uppercase">
                      <span className="flex items-center gap-1"><User size={12}/> {log.user}</span>
                      <span className="flex items-center gap-1"><Clock size={12}/> {log.date}</span>
                    </div>
                    <span className={`px-2 py-0.5 rounded text-[8px] font-black text-white ${log.action === 'INSERT' ? 'bg-green-500' : 'bg-orange-500'}`}>
                      {log.action}
                    </span>
                  </div>
                  <div className="p-4">
                    {/* عرض التغييرات - Logic عرض الفرق */}
                    {log.new_values && (
                      <div className="grid grid-cols-2 gap-4 text-[11px]">
                         {Object.keys(log.new_values).map(key => (
                           log.old_values?.[key] !== log.new_values[key] && (
                             <div key={key} className="flex flex-col border-b pb-1 border-slate-100">
                               <span className="text-slate-400 font-bold uppercase text-[9px]">{key}</span>
                               <div className="flex items-center gap-2">
                                 <span className="text-red-400 line-through">{String(log.old_values?.[key] || 'NULL')}</span>
                                 <ArrowRight size={10} className="text-slate-300"/>
                                 <span className="text-blue-900 font-black">{String(log.new_values[key])}</span>
                               </div>
                             </div>
                           )
                         ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuditHistoryModal;